import { Component, OnInit } from '@angular/core';
import { RankingListComponent } from '../ranking-list/ranking-list.component';
import { SharedModule } from '@app/shared/shared.module';
import { SettingsService } from '@app/services/settings/settings.service';

@Component({
  selector: 'app-ranking-home',
  standalone: true,
  imports: [
		SharedModule,
		RankingListComponent,
	],
  templateUrl: './ranking-home.component.html',
  styleUrl: './ranking-home.component.scss'
})
export class RankingHomeComponent implements OnInit {
	public loading:boolean = false;
	public year: string = "...";

	constructor(
		private settings: SettingsService,
	) {
	}
	ngOnInit(): void {
		this.loading = true;
		this.settings.getCurrentYear()
		.then(year => this.year = year.toString())
		.finally(() => this.loading = false);
	}

}
